import { IExampleData } from '../types';

/**
 * biData 测试示例数据集合
 */
export const EXAMPLE_DATA: IExampleData[] = [
  {
    name: '趋势图示例（单指标）',
    description: '包含完整字段的标准折线图数据，用于测试正常渲染流程',
    data: `{
      "data_id": "example_line_chart_001",
      "title": "用户增长趋势",
      "data": {
        "version": "2.0",
        "metrics_info": [
          {
            "data_key": "user_count",
            "name": "用户数",
            "format": "number"
          }
        ],
        "dimension_info": [
          {
            "data_key": "date",
            "name": "日期",
            "value": ["2024-01", "2024-02", "2024-03", "2024-04", "2024-05"]
          }
        ],
        "data": [
          { "date": "2024-01", "user_count": 1000 },
          { "date": "2024-02", "user_count": 1500 },
          { "date": "2024-03", "user_count": 2200 },
          { "date": "2024-04", "user_count": 2800 },
          { "date": "2024-05", "user_count": 3500 }
        ],
        "xAxis": ["date"],
        "yAxis": ["value"],
        "legends": [],
        "chat_type": "trend",
        "filter_info": []
      },
      "system": "dashboard"
    }`,
  },
  {
    name: '趋势图示例（多指标）',
    description: '包含多个指标的柱状图数据，测试多指标渲染',
    data: `{
      "data_id": "example_bar_chart_001",
      "title": "收入与成本对比",
      "data": {
        "version": "2.0",
        "metrics_info": [
          {
            "data_key": "revenue",
            "name": "收入",
            "format": "number"
          },
          {
            "data_key": "cost",
            "name": "成本",
            "format": "number"
          }
        ],
        "dimension_info": [
          {
            "data_key": "month",
            "name": "月份",
            "value": ["1月", "2月", "3月", "4月"]
          }
        ],
        "data": [
          { "month": "1月", "revenue": 5000, "cost": 3000 },
          { "month": "2月", "revenue": 6000, "cost": 3500 },
          { "month": "3月", "revenue": 7200, "cost": 4000 },
          { "month": "4月", "revenue": 6800, "cost": 3800 }
        ],
        "xAxis": ["month"],
        "yAxis": ["value"],
        "legends": [],
        "chat_type": "trend",
        "filter_info": []
      },
      "system": "dashboard",
      "from": "agent"
    }`,
  },
  {
    name: '复杂示例（带筛选器）',
    description: '包含 filter_info 的复杂数据，测试完整功能',
    data: `{
      "data_id": "example_complex_001",
      "title": "游戏DAU趋势",
      "data": {
        "version": "2.0",
        "metrics_info": [
          {
            "data_key": "dau",
            "name": "日活跃用户数",
            "format": "number"
          },
          {
            "data_key": "pay_user",
            "name": "付费用户数",
            "format": "number"
          }
        ],
        "dimension_info": [
          {
            "data_key": "date",
            "name": "日期",
            "value": ["2024-01-01", "2024-01-02", "2024-01-03"]
          },
          {
            "data_key": "platform",
            "name": "平台",
            "value": ["iOS", "Android"]
          }
        ],
        "filter_info": [
          {
            "data_key": "platform",
            "name": "平台",
            "filter_type": "normal"
          }
        ],
        "data": [
          { "date": "2024-01-01", "platform": "iOS", "dau": 10000, "pay_user": 1200 },
          { "date": "2024-01-01", "platform": "Android", "dau": 15000, "pay_user": 1800 },
          { "date": "2024-01-02", "platform": "iOS", "dau": 10500, "pay_user": 1250 },
          { "date": "2024-01-02", "platform": "Android", "dau": 15800, "pay_user": 1900 },
          { "date": "2024-01-03", "platform": "iOS", "dau": 11200, "pay_user": 1300 },
          { "date": "2024-01-03", "platform": "Android", "dau": 16500, "pay_user": 2000 }
        ],
        "xAxis": ["date"],
        "legends": [],
        "chat_type": "trend",
        "yAxis": ["value"]
      },
      "system": "dashboard",
      "from": "agent"
    }`,
  },
  {
    name: '异常示例 1（缺少必填字段）',
    description: '缺少 data.xAxis 字段，用于测试字段缺失检测',
    data: `{
      "data": {
        "metrics_info": [
          { "data_key": "value", "name": "数值" }
        ],
        "dimension_info": [
          { "data_key": "category", "name": "类别" }
        ],
        "data": [
          { "category": "A", "value": 100 },
          { "category": "B", "value": 200 }
        ]
      }
    }`,
  },
  {
    name: '异常示例 2（类型错误）',
    description: 'metrics_info 不是数组类型，用于测试类型错误检测',
    data: `{
      "data": {
        "metrics_info": "这应该是一个数组",
        "dimension_info": [],
        "data": [],
        "xAxis": []
      }
    }`,
  },
  {
    name: '异常示例 3（数据为空）',
    description: '所有数据数组为空，用于测试空数据警告',
    data: `{
      "data": {
        "metrics_info": [],
        "dimension_info": [],
        "data": [],
        "xAxis": []
      }
    }`,
  },
  {
    name: '异常示例 4（缺少 data_key）',
    description: 'metrics_info 元素缺少 data_key 字段',
    data: `{
      "data": {
        "metrics_info": [
          { "name": "指标1" },
          { "name": "指标2" }
        ],
        "dimension_info": [
          { "data_key": "dim1", "name": "维度1" }
        ],
        "data": [
          { "dim1": "A", "value1": 100 }
        ],
        "xAxis": ["dim1"]
      }
    }`,
  }
];

/**
 * 默认示例数据（首次加载显示）
 */
export const DEFAULT_EXAMPLE = EXAMPLE_DATA[0].data;

/**
 * 原生 ECharts options 示例集合
 * 用于在「原生图表」模式下提供可一键加载的标准 echarts 配置
 */
export const ECHARTS_OPTION_EXAMPLES: IExampleData[] = [
  {
    name: '折线图（基础）',
    description: '最简单的折线图，包含 xAxis / yAxis / series',
    mode: 'echartsOption',
    data: `{
  "title": { "text": "月度销售额" },
  "tooltip": { "trigger": "axis" },
  "xAxis": {
    "type": "category",
    "data": ["1月", "2月", "3月", "4月", "5月", "6月"]
  },
  "yAxis": { "type": "value" },
  "series": [
    {
      "name": "销售额",
      "type": "line",
      "smooth": true,
      "data": [820, 932, 901, 934, 1290, 1330]
    }
  ],
  "height": 400
}`,
  },
  {
    name: '柱状图（多系列堆叠）',
    description: '多系列堆叠柱状图，演示 stack 与 legend',
    mode: 'echartsOption',
    data: `{
  "title": { "text": "渠道收入构成" },
  "tooltip": { "trigger": "axis", "axisPointer": { "type": "shadow" } },
  "legend": { "data": ["渠道A", "渠道B", "渠道C"] },
  "xAxis": {
    "type": "category",
    "data": ["Q1", "Q2", "Q3", "Q4"]
  },
  "yAxis": { "type": "value" },
  "series": [
    { "name": "渠道A", "type": "bar", "stack": "total", "data": [320, 332, 301, 334] },
    { "name": "渠道B", "type": "bar", "stack": "total", "data": [120, 132, 101, 134] },
    { "name": "渠道C", "type": "bar", "stack": "total", "data": [220, 182, 191, 234] }
  ],
  "height": 400
}`,
  },
  {
    name: '饼图（环形）',
    description: '非笛卡尔坐标系图表示例，无需 xAxis/yAxis',
    mode: 'echartsOption',
    data: `{
  "title": { "text": "用户来源", "left": "center" },
  "tooltip": { "trigger": "item" },
  "legend": { "orient": "vertical", "left": "left" },
  "series": [
    {
      "name": "来源",
      "type": "pie",
      "radius": ["40%", "70%"],
      "avoidLabelOverlap": false,
      "label": { "show": true, "formatter": "{b}: {d}%" },
      "data": [
        { "value": 1048, "name": "搜索" },
        { "value": 735,  "name": "直接访问" },
        { "value": 580,  "name": "邮件" },
        { "value": 484,  "name": "联盟广告" },
        { "value": 300,  "name": "视频" }
      ]
    }
  ],
  "height": 400
}`,
  },
  {
    name: '混合图（柱+折线双 Y 轴）',
    description: '左右双 Y 轴 + 柱状/折线混合，演示复杂配置',
    mode: 'echartsOption',
    data: `{
  "tooltip": { "trigger": "axis", "axisPointer": { "type": "cross" } },
  "legend": { "data": ["蒸发量", "降水量", "平均温度"] },
  "xAxis": [
    {
      "type": "category",
      "data": ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
      "axisPointer": { "type": "shadow" }
    }
  ],
  "yAxis": [
    { "type": "value", "name": "水量", "position": "left" },
    { "type": "value", "name": "温度", "position": "right" }
  ],
  "series": [
    {
      "name": "蒸发量",
      "type": "bar",
      "data": [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
    },
    {
      "name": "降水量",
      "type": "bar",
      "data": [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
    },
    {
      "name": "平均温度",
      "type": "line",
      "yAxisIndex": 1,
      "data": [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
    }
  ],
  "height": 420
}`,
  },
  {
    name: '异常示例（缺少 series）',
    description: '原生 options 缺少 series，用于测试结构校验',
    mode: 'echartsOption',
    data: `{
  "title": { "text": "无系列" },
  "xAxis": { "type": "category", "data": ["A","B","C"] },
  "yAxis": { "type": "value" }
}`,
  },
];

